import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import PageBanner from "@/components/PageBanner";
import Reveal from "@/components/Reveal";
import { FAQS } from "@/data/site";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <div data-testid="faq-page">
      <PageBanner
        eyebrow="FAQ"
        title="Questions, answered honestly"
        subtitle="Everything you might want to know about our apple cider vinegar, its benefits and how we work. Still curious? We're always happy to help."
        testId="faq-banner"
      />

      <section className="mx-auto max-w-3xl px-5 py-16 md:px-8 md:py-24">
        <div className="divide-y divide-line border-y border-line">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.04}>
                <div data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-trigger-${i}`}
                    className="flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className="font-heading text-xl text-forest md:text-2xl">{f.q}</span>
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-line text-sage">
                      {isOpen ? <Minus className="h-4 w-4" strokeWidth={2} /> : <Plus className="h-4 w-4" strokeWidth={2} />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 pr-14 text-base leading-relaxed text-ink/65">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 rounded-3xl bg-sand p-8 text-center md:p-10">
            <h3 className="font-heading text-2xl text-forest md:text-3xl">Still have a question?</h3>
            <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-ink/65">
              Our team is here to help you find the right product and answer anything else.
            </p>
            <Link
              to="/contact"
              data-testid="faq-contact-btn"
              className="mt-6 inline-block rounded-full bg-sage px-8 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-forest"
            >
              Contact Us
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
